import { useState, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonList,
  IonItem,
  IonLabel,
  IonToggle,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { getSettings, saveSettings, AppSettings } from '../services/StorageService';
import './Settings.css';

const Settings: React.FC = () => {
  const [settings, setSettings] = useState<AppSettings>({
    soundEnabled: true,
    controlType: 'dpad',
    difficulty: 'normal',
  });

  useEffect(() => {
    getSettings().then(setSettings);
  }, []);

  const update = (partial: Partial<AppSettings>) => {
    const next = { ...settings, ...partial };
    setSettings(next);
    saveSettings(next);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>Settings</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="settings-content">
        <IonList>
          <IonItem>
            <IonLabel>Sound Effects</IonLabel>
            <IonToggle
              checked={settings.soundEnabled}
              onIonChange={(e) => update({ soundEnabled: e.detail.checked })}
            />
          </IonItem>

          <IonItem>
            <IonLabel>Controls</IonLabel>
            <IonSelect
              value={settings.controlType}
              onIonChange={(e) => update({ controlType: e.detail.value })}
            >
              <IonSelectOption value="dpad">D-Pad</IonSelectOption>
              <IonSelectOption value="swipe">Swipe</IonSelectOption>
            </IonSelect>
          </IonItem>

          <IonItem>
            <IonLabel>Difficulty</IonLabel>
            <IonSelect
              value={settings.difficulty}
              onIonChange={(e) => update({ difficulty: e.detail.value })}
            >
              <IonSelectOption value="easy">Easy</IonSelectOption>
              <IonSelectOption value="normal">Normal</IonSelectOption>
              <IonSelectOption value="hard">Hard</IonSelectOption>
            </IonSelect>
          </IonItem>
        </IonList>

        <div className="settings-info">
          <p>ChompChomp v0.1.0</p>
          <p>Help Chomp the Mouse eat all the cheese while avoiding the cats!</p>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Settings;
